var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// Map from cart contents to the richer model used for editing
// We may be restoring from an old kit that is no longer valid in the current catalog (for reordering old
// kits), so we only overwrite the default state with data we've validated against the catalog.
import { Plexity } from "../../KitDeserializer";
import { defaultChromogenState } from "../automated-pro/AdminEditKitForm";
import { ProtocolTypeEnum } from "../automated-pro/EditKitForm";
import { chromogenKitToChromogenFormState, detectComponentToDetectFormState } from "../automated-pro/RnaCishKitToAdminFormState";
import { defaultProbeSetState } from "../rna-fish/EditKitForm";
import { probeKitToProbeFormState } from "../rna-fish/RnaFishKitToFormState";
import { defaultManualProDetectState } from "./ManualProAdminKitForm";
import { defaultBufferState } from "./ManualProConsumerKitForm";
export var manualProKitToAdminFormState = function (catalog, kit, kitPrice) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    // probe set
    var probeSetEnabled = false;
    var probeSetState = defaultProbeSetState(catalog, false, true);
    if (kit.probeSet !== undefined) {
        probeSetEnabled = true;
        probeSetState = probeKitToProbeFormState(probeSetState, kit.probeSet, catalog, false, undefined, kitPrice)[0];
    }
    // amp state
    var ampCatalog = catalog.proAmplifier;
    var detectEnabled = false;
    var detectPresetScale = (_a = kit.detect) === null || _a === void 0 ? void 0 : _a.presetScale;
    var defaultDetectPresetScale = defaultManaulProDetectPresetScale(catalog);
    var detectState = defaultManualProDetectState(ampCatalog, defaultDetectPresetScale);
    if (kit.detect !== undefined) {
        detectEnabled = true;
        detectState = detectComponentToDetectFormState(Plexity.OnePlex, detectState, kit.detect, catalog, true, kitPrice);
        if (!probeSetEnabled) {
            probeSetState = __assign(__assign({}, probeSetState), { hcrAmplifier: (_b = detectState.channels[0].hcrAmplifier) !== null && _b !== void 0 ? _b : ampCatalog.defaultHcrAmplifier });
        }
    }
    // chromogen state
    var chromogenState = defaultChromogenState();
    var chromogenEnabled = kit.chromogen != null || kit.detect != null;
    if (kit.chromogen !== undefined) {
        chromogenState = chromogenKitToChromogenFormState(chromogenState, kit.chromogen, catalog, kitPrice);
    }
    // manual buffer state
    var manualBuffersEnabled = false;
    var manualBuffersState = defaultBufferState(catalog);
    if (kit.buffers !== undefined) {
        manualBuffersEnabled = true;
        if (kitPrice && kitPrice.buffersPriceCustom) {
            manualBuffersState = __assign(__assign({}, manualBuffersState), { customPrice: {
                    listPriceCents: 0,
                    effectivePriceCents: kitPrice.buffersPriceCents,
                } });
        }
        manualBuffersState = __assign(__assign({}, manualBuffersState), { ampWash: kit.buffers.ampWashBuffer, probeWash: kit.buffers.probeWashBuffer, hybridization: kit.buffers.hybridizationBuffer });
    }
    var sampleTypeFormState = {
        sampleType: (_c = catalog.manualProBuffer.sampleTypes.find(function (t) { return t.id === kit.sampleType.id; })) !== null && _c !== void 0 ? _c : catalog.manualProBuffer.defaultSampleType
    };
    var allDetectScale;
    if (detectEnabled) {
        allDetectScale = (_h = (_e = (_d = kit.detect) === null || _d === void 0 ? void 0 : _d.customScale) !== null && _e !== void 0 ? _e : (_g = (_f = kit.detect) === null || _f === void 0 ? void 0 : _f.presetScale) === null || _g === void 0 ? void 0 : _g.units) !== null && _h !== void 0 ? _h : catalog.defaultManualProScale;
    }
    else if (chromogenEnabled) {
        allDetectScale = (_o = (_k = (_j = kit.chromogen) === null || _j === void 0 ? void 0 : _j.customScale) !== null && _k !== void 0 ? _k : (_m = (_l = kit.chromogen) === null || _l === void 0 ? void 0 : _l.presetScale) === null || _m === void 0 ? void 0 : _m.units) !== null && _o !== void 0 ? _o : catalog.defaultManualProScale;
    }
    else {
        allDetectScale = catalog.defaultManualProScale;
    }
    return {
        detectPresetScale: detectPresetScale,
        detectState: detectState,
        detectEnabled: detectEnabled,
        buffersEnabled: manualBuffersEnabled,
        buffersState: manualBuffersState,
        chromogenPresetScale: (_p = kit.chromogen) === null || _p === void 0 ? void 0 : _p.presetScale,
        chromogenEnabled: chromogenEnabled,
        chromogenState: chromogenState,
        comment: kit.comment,
        errors: [],
        price: undefined,
        priceLoading: false,
        probeSetEnabled: probeSetEnabled,
        probeSetState: probeSetState,
        sampleTypeFormState: sampleTypeFormState,
        detectScale: allDetectScale
    };
};
export var defaultManaulProDetectPresetScale = function (catalog) {
    return catalog.presetScales.presetProDetectScales.find(function (s) {
        return s.units === catalog.defaultAutomatedProScale
            && s.platform.id === ProtocolTypeEnum.MANUAL;
    });
};
//# sourceMappingURL=ManualProKitToAdminFormState.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/manual-pro/ManualProKitToAdminFormState.js
// module id = 333
// module chunks = 0